import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EquipmentProjectApiModel } from '../models/api/equipment-project-api-model.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EquipmentProjectService {
  private apiUrl = `${environment.apiEndPoint}/EquipmentProject`; // Adjust the base URL as needed

  constructor(private http: HttpClient) { }

  getAll(): Observable<EquipmentProjectApiModel[]> {
    return this.http.get<EquipmentProjectApiModel[]>(this.apiUrl);
  }

  getByProjectId(projectId: number): Observable<EquipmentProjectApiModel[]> {
    return this.http.get<EquipmentProjectApiModel[]>(`${this.apiUrl}/project/${projectId}`);
  }

  getById(id: number): Observable<EquipmentProjectApiModel> {
    return this.http.get<EquipmentProjectApiModel>(`${this.apiUrl}/${id}`);
  }

  add(item: EquipmentProjectApiModel): Observable<EquipmentProjectApiModel> {
    return this.http.post<EquipmentProjectApiModel>(this.apiUrl, item);
  }

  update(item: EquipmentProjectApiModel): Observable<EquipmentProjectApiModel> {
    return this.http.put<EquipmentProjectApiModel>(`${this.apiUrl}/${item.equipmentProjectId}`, item);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}